import OptimizerEditDto from './OptimizerEditDto';

export class DualAnnealingOptimizerEditDto extends OptimizerEditDto {
	constructor() {
		super();
		/** @type {number} */
		this.maxiter = null;
		/** @type {number} */
		this.initialTemp = null;
		/** @type {number} */
		this.restartTempRatio = null;
		/** @type {number} */
		this.visit = null;
		/** @type {number} */
		this.accept = null;
	}

	/**
	 * @typedef {Object} _DualAnnealingOptimizerEditDtoProps
	 * @property {number} maxiter
	 * @property {number} initialTemp
	 * @property {number} restartTempRatio
	 * @property {number} visit
	 * @property {number} accept
	 *
	 * @typedef {import("./OptimizerEditDto").OptimizerEditDtoProps & _DualAnnealingOptimizerEditDtoProps} DualAnnealingOptimizerEditDtoProps
	 */
	/**
	 *
	 * @param {DualAnnealingOptimizerEditDtoProps} props
	 * @returns {DualAnnealingOptimizerEditDto}
	 */
	setup(props) {
		super.setup(props);
		this.maxiter = props.maxiter;
		this.initialTemp = props.initialTemp;
		this.restartTempRatio = props.restartTempRatio;
		this.visit = props.visit;
		this.accept = props.accept;
		return this;
	}
}

export default DualAnnealingOptimizerEditDto;
